import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking';

export const PACKAGE_NAME = 'jiraBusinessCalendar';

export const MAIN_EXPERIENCE: ExperienceDetails = {
	experience: 'calendarView',
	experienceId: 'main',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};
export const INLINE_CREATE_EXPERIENCE: ExperienceDetails = {
	experience: 'inlineCreate',
	experienceId: 'calendar',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};
export const SCHEDULE_ITEM_EXPERIENCE: ExperienceDetails = {
	experience: 'scheduleItem',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};
export const VIEW_UNSCHEDULED_SIDEBAR_EXPERIENCE: ExperienceDetails = {
	experience: 'viewUnscheduledSidebar',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};

export const VIEW_RELEASE_EXPERIENCE: ExperienceDetails = {
	experience: 'ViewReleaseInCalendar',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};

export const FETCH_RELEASE_EXPERIENCE: ExperienceDetails = {
	experience: 'fetchReleasesInCalendar',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};

export const FETCH_CONNECTED_JSW_PROJECTS_EXPERIENCE: ExperienceDetails = {
	experience: 'fetchConnectedJswProjects',
	packageName: PACKAGE_NAME,
	teamName: 'a4t-werewolves',
};

export const CONNECT_JSW_PROJECT_EXPERIENCE: ExperienceDetails = {
	experience: 'connectJswProjectInCalendar',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};

export const DISCONNECT_JSW_PROJECT_EXPERIENCE: ExperienceDetails = {
	experience: 'disconnectJswProjectInCalendar',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};

export const CALENDAR_ISSUE = 'ISSUE' as const;

export const RELEASES_IN_CALENDAR_SUPPORT_ARTICLE =
	'https://support.atlassian.com/jira-work-management/docs/surface-software-team-releases-in-business-team-calendars/';

export const DRAGGING_UNSCHEDULED_ITEM_CLASS_NAME = 'fc-dragging-unscheduled-item';
